var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightMarkerOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#979797;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.3,2.6c-4.1,0-7.4,3.3-7.4,7.4s3.3,7.4,7.4,7.4c4.1,0,7.4-3.3,7.4-7.4S16.3,2.6,12.3,2.6z M12.3,16.6 c-3.7,0-6.7-3-6.7-6.7c0-3.7,3-6.7,6.7-6.7c3.7,0,6.7,3,6.7,6.7C18.9,13.7,16,16.6,12.3,16.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.4,
    y: 9.1,
    className: "st1",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.3,3.3c-3.7,0-6.7,3-6.7,6.7c0,3.7,3,6.7,6.7,6.7c3.7,0,6.7-3,6.7-6.7C18.9,6.3,16,3.3,12.3,3.3z  M17.3,10.8v1.7h-2.5V15h-1.7v-2.5h-1.7V15H9.8v-2.5H7.2v-1.7h2.5V9.1H7.2V7.4h2.5V4.9h1.7v2.5h1.7V4.9h1.7v2.5h2.5v1.7h-2.5v1.7 H17.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17.3,9.1V7.4h-2.5V4.9h-1.7v2.5h-1.7V4.9H9.8v2.5H7.2v1.7h2.5v1.7H7.2v1.7h2.5V15h1.7v-2.5h1.7V15h1.7v-2.5 h2.5v-1.7h-2.5V9.1H17.3z M13.1,10.8h-1.7V9.1h1.7V10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3,0.8c-5.1,0-9.2,4.1-9.2,9.2c0,3.3,1.8,6.2,4.4,7.8l4.8,5.4l4.8-5.4c2.6-1.6,4.4-4.5,4.4-7.8 C21.5,4.9,17.3,0.8,12.3,0.8z M12.3,17.3c-4.1,0-7.4-3.3-7.4-7.4s3.3-7.4,7.4-7.4c4.1,0,7.4,3.3,7.4,7.4S16.3,17.3,12.3,17.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightMarkerOffline);
export default __webpack_public_path__ + "static/media/light-marker-offline.5edc18b182ba30edfb3e875925c711c8.svg";
export { ForwardRef as ReactComponent };